import {Injectable} from "@angular/core";
import {Api3Service} from "../../../../common/services/api3.service";
import {Api} from "../../../../common/services/api.service";
import {PartnerService} from "../../../../common/services/partner.service";


@Injectable()
export class PartnerPartMasterService {

    public constructor(private apiService: Api3Service) {
    }

    public getPartMasters(query: any = {}): Promise<Api.IResponse> {
        return this.apiService.request(Api.EMethod.Get,
            "partner/" + PartnerService.partner.slug + "/part-masters", {}, query);
    }

}
